"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import type { WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import { useWaveDropsLeaderboard } from "@/hooks/useWaveDropsLeaderboard";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import React from "react";
import { WaveLeaderboardDrop } from "./WaveLeaderboardDrop";
import { WaveLeaderboardEmptyState } from "./WaveLeaderboardEmptyState";
import { WaveLeaderboardLoading } from "./WaveLeaderboardLoading";
import { WaveLeaderboardLoadingBar } from "./WaveLeaderboardLoadingBar";
interface WaveLeaderboardDropsProps {
  readonly wave: ApiWave;
  readonly sort: WaveDropsLeaderboardSort;
  readonly onCreateDrop?: (() => void) | undefined;
  readonly curatedByGroupId?: string | undefined;
  readonly minPrice?: number | undefined;
  readonly maxPrice?: number | undefined;
  readonly priceCurrency?: string | undefined;
}
export const WaveLeaderboardDrops: React.FC<WaveLeaderboardDropsProps> = t0 => {
  const $ = _c(35);
  const {
    wave,
    sort,
    onCreateDrop,
    curatedByGroupId,
    minPrice,
    maxPrice,
    priceCurrency
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== curatedByGroupId || $[1] !== maxPrice || $[2] !== minPrice || $[3] !== priceCurrency || $[4] !== sort || $[5] !== wave.id) {
    t1 = {
      waveId: wave.id,
      sort,
      curatedByGroupId,
      minPrice,
      maxPrice,
      priceCurrency
    };
    $[0] = curatedByGroupId;
    $[1] = maxPrice;
    $[2] = minPrice;
    $[3] = priceCurrency;
    $[4] = sort;
    $[5] = wave.id;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t1);
  let t2;
  if ($[7] !== fetchNextPage || $[8] !== hasNextPage || $[9] !== isFetching || $[10] !== isFetchingNextPage) {
    t2 = async () => {
      if (hasNextPage && !isFetching && !isFetchingNextPage) {
        await fetchNextPage();
      }
    };
    $[7] = fetchNextPage;
    $[8] = hasNextPage;
    $[9] = isFetching;
    $[10] = isFetchingNextPage;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const intersectionElementRef = useIntersectionObserver(t2);
  let t3;
  if ($[12] !== pathname || $[13] !== router || $[14] !== searchParams) {
    t3 = drop => {
      const params = new URLSearchParams(searchParams.toString());
      params.set("drop", drop.id);
      router.push(`${pathname}?${params.toString()}`);
    };
    $[12] = pathname;
    $[13] = router;
    $[14] = searchParams;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const onDropClick = t3;
  if (isFetching && drops.length === 0) {
    let t4;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <WaveLeaderboardLoading />;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    return t4;
  }
  if (drops.length === 0) {
    let t4;
    if ($[17] !== onCreateDrop || $[18] !== wave) {
      t4 = <WaveLeaderboardEmptyState onCreateDrop={onCreateDrop} wave={wave} />;
      $[17] = onCreateDrop;
      $[18] = wave;
      $[19] = t4;
    } else {
      t4 = $[19];
    }
    return t4;
  }
  let t4;
  if ($[20] !== drops || $[21] !== onDropClick || $[22] !== wave) {
    let t5;
    if ($[24] !== onDropClick || $[25] !== wave) {
      t5 = drop_0 => <WaveLeaderboardDrop key={drop_0.id} drop={drop_0} wave={wave} onDropClick={onDropClick} />;
      $[24] = onDropClick;
      $[25] = wave;
      $[26] = t5;
    } else {
      t5 = $[26];
    }
    t4 = drops.map(t5);
    $[20] = drops;
    $[21] = onDropClick;
    $[22] = wave;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[27] !== isFetchingNextPage) {
    t5 = isFetchingNextPage && <WaveLeaderboardLoadingBar />;
    $[27] = isFetchingNextPage;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  let t6;
  if ($[29] !== intersectionElementRef) {
    t6 = <div ref={intersectionElementRef} />;
    $[29] = intersectionElementRef;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] !== t4 || $[32] !== t5 || $[33] !== t6) {
    t7 = <div className="tw-space-y-4">{t4}{t5}{t6}</div>;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  return t7;
};